module.exports = __webpack_public_path__ + "img/s3.801b1cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/s3.png
// module id = 6ahQ
// module chunks = 38 43